<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>设置管理->人脸优化</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 人脸优化 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <!-- <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                 -->
                <div style="display: inline-block; height:40px;">
                    <div style="width:200px;">
                        <el-cascader
                            :options="depts"
                            v-model="form.deptId"
                            placeholder="请选择机构名称"
                            :props="props"
                            collapse-tags
                            clearable></el-cascader>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="getData()">查询</el-button>
                </div>  
                <!-- <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setSubmit()">新增</el-button>
                </div> -->

            </div>
            <div style="font-size:12px;color:red;">注：人脸优化，至少勾选5个以上人脸图片。</div>
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                :element-loading-text = "loadingText"
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="人员信息" width="200">

                    <template slot-scope="scope">
                        <div v-if="scope.row.faceImage != null && scope.row.faceImage != ''">
                           <div>
                                <el-popover
                                    placement="right"
                                    title=""
                                    trigger="hover">
                                    <img :src="scope.row.faceImage"
                                        style="height:250px; max-width:330px"/>
                                    <img slot="reference" :src="scope.row.faceImage" :alt="scope.row.faceImage" style="height: 100px;width: 70px">
                                </el-popover>
                           </div>
                           <div style="width:220px;">
                                <div>姓名：{{scope.row.name}}</div>
                                <div>身份证：{{scope.row.idCardNumber}}</div>
                                <div>人员类型：{{scope.row.personType==1?'学生':'教职'}}</div>
                                <div>所属机构：{{scope.row.deptName}}</div>
                                <!-- <div v-if="scope.row.dateTime != null"> 创建时间：{{scope.row.dateTime}}</div> -->
                           </div>
                        </div>
                        <div v-else>
                            <div>姓名：{{scope.row.name}}</div>
                            <div>身份证：{{scope.row.idCardNumber}}</div>
                            <div>人员类型：{{scope.row.personType==1?'学生':'教职'}}</div>
                            <div>所属机构：{{scope.row.deptName}}</div>
                            <!-- <div v-if="scope.row.dateTime != null"> 创建时间：{{scope.row.dateTime}}</div> -->
                        </div>
                    </template>

                </el-table-column>
                <el-table-column prop="" label="勾选搜索结果（确认图片是否和本人相貌一致）">
                       
                    <template slot-scope="scope" v-if="scope.row.deviceFaceData != null">
                        <div v-for="(item,index) in scope.row.deviceFaceData.faceData" :key="index" style="float:left;margin-top:10px;">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover" >
                                <img :src="item.imageBase64"
                                    style="height:250px; max-width:330px"/>
                                <img slot="reference" :src="item.imageBase64" :alt="item.imageBase64" style="height:80px;width:80px">
                            </el-popover>
                             <el-checkbox v-model="scope.row.deviceFaceData.faceData[index].isSelect" style="z-index:10;right:16px;bottom:1px"></el-checkbox>
                            <br>相似度:{{item.alikeValue}}
                        </div>
                    </template>

                </el-table-column>
                <el-table-column fixed="right" label="操作"  width="120">
                    <template slot-scope="scope">
                        <div><el-checkbox v-model="scope.row.checked" @change="rowChange(scope.row)">全选</el-checkbox></div>
                        <div style="font-size:12px;color:red;">（打勾将全部人脸勾选）</div>
                        <el-button  @click.native.prevent="submit(scope.row)"
                            type="primary" round  v-if="scope.row.deviceFaceData != null"
                            style="margin-bottom:10px;">
                            提交人脸优化
                        </el-button>
                        <el-button  @click.native.prevent="clearFace(scope.row)"
                            type="warning" round  v-if="scope.row.deviceFaceData != null">
                            清空人脸序列
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--提交人脸优化-->
        <!-- <div v-if="submitVisible">
            <submit ref="submit"></submit>
        </div> -->
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import { MessageBox } from 'element-ui';
    // import submit from './Submit.vue';

    export default {
        name:"Face",
        data(){
            return{
                loading:false,
                loadingText:"",
                // submitVisible:false,
                props: { multiple: false,  checkStrictly: true },
                form:{
                    identityCard:"",
                    name:"",
                    deptId:[]
                },
                clearFaceTip:"",
                depts:[],
                data:[]
            }
        },
        created:function () {
            this.getDeptCascader();
        },
        components: {
            // submit
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = res.data.selects;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                if(deptId == ""){
                    this.$commonFn.showTip("请选择机构名称",3);
                    return;
                }
                this.loading=true;
                this.loadingText="查询时间较久，请耐心等待结果完成";
                
                let url  = this.listFaceUrl;
                let deptId="";
                if(this.form.deptId.length>0){
                    deptId=this.form.deptId[this.form.deptId.length-1];
                }

                // console.log(deptId);
                let data = {
                    name:this.form.name,
                    identityCard:this.form.identityCard,
                    deptId:deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                    //    this.clearFaceTip = res.data.clearFaceTip;
                    }else{
                        if(res.msg !=undefined && res.msg!=null && res.msg!=''){
                            this.$commonFn.showTip(res.msg,3);
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
            },
            submit(row){
                let faceDataArr=row.deviceFaceData;
                // 获取选中的人脸
                let faceData=new Array();
                for(let i=0;i<faceDataArr.faceData.length;i++){
                    if(faceDataArr.faceData[i].isSelect){
                        let faceObj={};
                        faceObj.faceNumber=faceDataArr.faceData[i].faceNumber;
                        faceObj.deviceNo=faceDataArr.faceData[i].deviceNo;
                        faceData.push(faceObj);
                    }
                }

                if(faceData.length == 0){
                    this.$commonFn.showTip('请选择优化人员，再进行提交操作',3);
                    return
                }
                // else if(faceData.length < 5){
                //     this.$commonFn.showTip('至少勾选5个以上人脸图片进行优化',3);
                //     return
                // }

                // 提交人脸优化
                let url= this.faceAddUrl;
                let data = {
                    idCardNumber:row.idCardNumber,
                    faceData:JSON.stringify(faceData),
                };
                // console.log(JSON.stringify(data));
                // return;
                this.loading=true;
                this.loadingText="人脸优化提交中，请耐心等待结果完成";
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        // 重新渲染清空人脸序列返回的值
                        let rtnData=res.data;
                        for(let i=0;i<this.data.length;i++){
                            let user=this.data[i];
                            for(let j=0;j<rtnData.length;j++){
                                // 身份证相同就修改faceData
                                if(rtnData[j].idCardNumber == user.idCardNumber){
                                    // 渲染列表数据
                                    this.data[i].deviceFaceData.faceData=rtnData[j].faceData;
                                    break;
                                }
                            }
                        }
                        row.checked=false; // 全选不打勾
                        this.$forceUpdate();
                    }else{
                        if(res.msg !=undefined && res.msg!=null && res.msg!=''){
                            this.$commonFn.showTip(res.msg,3);
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
            clearFace(row){
                MessageBox.confirm(this.clearFaceTip, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((resolve) => {
 
                    this.loading=true;
                    this.loadingText="清空人脸序列提交中，请耐心等待结果完成";

                    let url = this.clearFaceUrl;
                    let data = {
                        id:row.id,
                        parentId:row.parentId
                    };
                    // console.log(JSON.stringify(data));
                    // return;
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            // 重新渲染清空人脸序列返回的值
                            let rtnData=res.data;
                            for(let i=0;i<this.data.length;i++){
                                let user=this.data[i];
                                for(let j=0;j<rtnData.length;j++){
                                    // 身份证相同就修改faceData
                                    if(rtnData[j].idCardNumber == user.idCardNumber){
                                        // 渲染列表数据
                                        this.data[i].deviceFaceData.faceData=rtnData[j].faceData;
                                        break;
                                    }
                                }
                            }
                            row.checked=false; // 全选不打勾
                            this.$forceUpdate();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                        this.loading=false;
                    }, (err) => {
                        this.$commonFn.showTip(err,3);
                    });
                }).catch(() => {
                });
            },
            rowChange(row){ // 全选/全不选
                let faceDataArr=row.deviceFaceData;
                // 获取选中的人脸
                let faceData=new Array();
                for(let i=0;i<faceDataArr.faceData.length;i++){
                   faceDataArr.faceData[i].isSelect=row.checked;
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/face/Face.vue